module.exports = __webpack_public_path__ + "img/wjc.005eec3a.svg";